import {
  laptopLargeMax,
  laptopMax,
  laptopMaxXL,
  mobileXXLargeMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import BlankMacbook from '@propertypal/shared/src/resources/icons/agent-advantage/blank_macbook.png';
import intro1 from '@propertypal/shared/src/resources/icons/agent-advantage/intro-01.jpg';
import intro2 from '@propertypal/shared/src/resources/icons/agent-advantage/intro-02.jpg';
import intro3 from '@propertypal/shared/src/resources/icons/agent-advantage/intro-03.jpg';
import valuations1 from '@propertypal/shared/src/resources/icons/agent-advantage/valuations-01.jpg';
import valuations2 from '@propertypal/shared/src/resources/icons/agent-advantage/valuations-02.jpg';
import platform from '@propertypal/shared/src/utils/platform';
import ProductsTabs from '@propertypal/web-ui/src/tabs/ProductsTabs';
import styled, { keyframes } from 'styled-components';

export const BACKGROUND_COLOR = '#f5d0c0';

export const PagerWrapper = styled.div`
  overflow: hidden;
`;

export const Primary = styled.span`
  color: ${(props) => props.theme.primary};
`;

export const Black = styled.span`
  color: #000;
`;

export const White = styled.span`
  color: #fff;
`;

export const Wrapper = styled.div<{ mobileReverse?: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  max-width: 1290px;
  padding: 60px 45px;

  @media (${laptopMax}) {
    flex-direction: column;
    padding-top: 80px;

    ${(props) =>
      props.mobileReverse &&
      `
      flex-direction: column-reverse;
    `}
  }

  @media (${tabletMax}) {
    padding: 80px 15px;
  }
`;

export const CircleNumber = styled.h4<{ color?: string }>`
  width: 120px;
  height: 120px;
  text-align: center;
  font-size: 70px;
  background-color: ${(props) => props.color || props.theme.primary};
  border-radius: 60px;
  color: ${(props) => props.theme.white};
  padding: 10px 0 0;

  @media (${laptopMaxXL}) {
    width: 90px;
    height: 90px;
    font-size: 50px;
    padding: 8px 0 0;
  }
`;

export const Header = styled.div`
  position: relative;
`;

export const HeaderBg = styled.div`
  background-color: ${(props) => props.theme.backgroundLightest};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -2;
`;

export const HeaderCircle = styled.div`
  position: absolute;
  width: 60%;
  min-width: 960px;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 0 0 600px 0;
  background-color: ${BACKGROUND_COLOR};
  z-index: -1;

  @media (${laptopMax}) {
    min-width: initial;
    width: 100%;
    height: 620px;
    border-radius: 0 0 300px 0;
  }
`;

export const HeaderTextBox = styled.div`
  width: 100%;
  max-width: 675px;
  margin: 120px 0 180px;
  padding-right: 30px;

  svg {
    width: 100%;
    max-width: 375px;
    height: 135px;
    display: block;
    margin-left: -14px;
  }

  h1 {
    font-family: ${platform.headingFont};
    font-size: 60px;
    line-height: 66px;
    margin-bottom: 15px;
  }

  h2 {
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 30px;
  }

  @media (${laptopMax}) {
    max-width: 600px;
    margin: 30px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 0;

    svg {
      margin: 0 auto;
    }

    h1 {
      font-size: 38px;
      line-height: 38px;
      text-align: center;
    }

    h2 {
      font-size: 20px;
      line-height: 24px;
      text-align: center;
    }
  }

  @media (${tabletMax}) {
    h1 {
      font-size: 28px;
    }

    h2 {
      font-size: 18px;
    }
  }
`;

export const HeaderImages = styled.div`
  position: relative;
  margin-top: 60px;

  > img:first-child {
    height: 600px;
  }

  @media (${laptopMax}) {
    width: 100%;
    max-width: 325px;
    margin: 15px auto 0;

    > img:first-child {
      height: 320px;
    }
  }
`;

export const TopLaptopAnimations = styled.div`
  background-image: url(${BlankMacbook.src});
  background-size: contain;
  position: absolute;
  width: 761px;
  height: 460px;
  top: 320px;
  left: 50px;

  @media (${laptopMax}) {
    width: 330px;
    height: 200px;
    top: 200px;
    left: 20px;
  }
`;

const topLaptopAnimation = keyframes`
  0%, 18%{
    background-image: url(${intro1.src});
  }
  34%, 52% {
    background-image: url(${intro2.src});
  }
  68%, 86% {
    background-image: url(${intro3.src});
  }
  100% {
    background-image: url(${intro1.src});
  }
`;

export const TopLaptopImage = styled.div`
  position: absolute;
  background-size: cover;
  top: 37px;
  left: 102px;
  width: 558px;
  height: 348px;
  animation-name: ${topLaptopAnimation};
  animation-duration: 10s;
  animation-iteration-count: infinite;

  @media (${laptopMax}) {
    top: 15px;
    left: 45px;
    width: 240px;
    height: 154px;
  }
`;

export const SummaryBox = styled.div`
  padding-top: 120px;
  margin-bottom: 120px;
  background-color: ${(props) => props.theme.backgroundLightest};

  h2 {
    font-family: ${platform.headingFont};
    font-size: 48px;
    text-align: center;
    margin-bottom: 30px;
  }

  @media (${laptopMax}) {
    h2 {
      font-size: 32px;
    }

    margin-bottom: 30px;
  }
`;

export const SummaryText = styled.p`
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  margin: 60px 0;

  @media (${laptopMaxXL}) {
    margin: 30px 0;
  }

  @media (${laptopMax}) {
    font-size: 18px;
  }
`;

export const SummaryItem = styled.div`
  position: relative;
  width: 30%;
  padding-bottom: 40px;

  svg {
    position: absolute;
    top: 55px;
    left: 55px;
    height: 80px;
  }

  @media (${laptopMaxXL}) {
    svg {
      top: 50px;
      left: 50px;
      height: 60px;
    }
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 -80px;

  @media (${laptopLargeMax}) {
    margin: 0;
  }

  @media (max-width: 1080px) {
    flex-wrap: wrap;
    max-width: 480px;
    width: 100%;
    margin: 0 auto;

    ${SummaryItem} {
      flex-basis: 50%;
    }
  }

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: center;

    ${SummaryItem} {
      width: 230px;
    }
  }
`;

export const CityScapeContainer = styled.div`
  width: 100%;
  margin-top: 30px;

  svg {
    min-height: 200px;
    height: 100%;
  }
`;

export const DetailsBox = styled.div`
  position: relative;

  ${Wrapper} {
    margin: 160px auto;

    @media (${laptopMax}) {
      margin: 60px auto;
    }
  }
`;

export const DetailsText = styled.p`
  font-size: 20px;
  margin: 15px 0;
  line-height: 32px;

  @media (${laptopMax}) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const DetailsLaptop = styled.div`
  position: relative;
  width: 850px;
  aspect-ratio: 850 / 514;
  background-image: url(${BlankMacbook.src});
  background-size: contain;

  @media (${laptopMaxXL}) {
    width: 100%;
  }

  img {
    position: absolute;
    object-fit: cover;
    width: 73%;
    height: 76%;
    top: 8%;
    left: 13.5%;
  }
`;

export const LaptopBanner = styled.div`
  position: absolute;
  top: 10px;
  left: 90px;

  p {
    position: absolute;
    top: 53px;
    font-weight: 900;
    font-size: 20px;
    transform: rotate(-45deg);
  }

  @media (${laptopMaxXL}) {
    top: 2%;
    left: 10.9%;
  }

  @media (${mobileXXLargeMax}) {
    transform: scale(0.8) translate(-22px, -22px);
  }
`;

export const VideoBox = styled.div`
  position: absolute;
  top: 40px;
  left: 114px;
  width: 624px;
  height: 394px;

  @media (${laptopMaxXL}) {
    top: 8%;
    left: 13%;
    width: 74%;
    height: 76%;
  }
`;

const valuationsAnimation = keyframes`
  0%, 30% {
    background-image: url(${valuations1.src});
  }
  50%, 80% {
    background-image: url(${valuations2.src});
  }
  100% {
    background-image: url(${valuations1.src});
  }
`;

export const ValuationsAnimation = styled.div`
  position: absolute;
  background-size: cover;
  width: 73%;
  height: 76%;
  top: 8%;
  left: 13.5%;
  animation-name: ${valuationsAnimation};
  animation-duration: 6s;
  animation-iteration-count: infinite;
`;

export const DetailsColumn = styled.div<{ align: string; type: 'details' | 'list' }>`
  flex: 1;
  max-width: 50%;
  display: flex;
  flex-direction: column;

  > svg:first-child {
    width: 100%;
    max-width: 350px;
    height: 120px;
    margin-top: 40px;
    margin-left: -10px;
  }

  ${(props) =>
    props.align === 'left' &&
    `
    ${CircleNumber} {
      align-self: flex-end;
    }
  `}

  ${(props) =>
    props.align === 'left' &&
    props.type === 'details' &&
    `
    padding-right: 60px;
    
    ${DetailsLaptop} {
      margin-left: -95px;
    }
  `}

  ${(props) =>
    props.align === 'right' &&
    props.type === 'details' &&
    `
    padding-left: 60px;
    
    ${DetailsLaptop} {
      margin-left: -200px;
    }
  `}
  
  h3 {
    font-size: 24px;
    margin-bottom: 30px;
  }

  @media (${laptopMaxXL}) {
    ${DetailsLaptop} {
      margin-left: -65px;
    }
  }

  @media (${laptopMax}) {
    position: relative;
    max-width: 100%;
    padding: 0;
    margin: 30px 0;

    ${DetailsLaptop} {
      margin: 0;
    }
  }
`;

export const DetailsBg = styled.div<{ align: string; color: string }>`
  background-color: ${(props) => props.color};
  position: absolute;
  z-index: -1;
  top: 0;
  width: 50%;
  height: 100%;

  ${(props) =>
    props.align === 'left' &&
    `
    left: 0;
    border-radius: 0 220px 220px 0;
  `}

  ${(props) =>
    props.align === 'right' &&
    `
    right: 0;
    border-radius: 220px 0 0 220px;
  `}
  
  svg {
    position: absolute;
    top: 10px;

    ${(props) =>
      props.align === 'right' &&
      `
      right: 10px;    
    `}

    ${(props) =>
      props.align === 'left' &&
      `
      left: 10px;
      transform: scaleX(-1);
    `}
  }

  @media (${laptopMax}) {
    width: calc(100% + 45px);

    ${(props) =>
      props.align === 'left' &&
      `
      left: -45px;
      border-radius: 0 120px 120px 0;
    `}

    ${(props) =>
      props.align === 'right' &&
      `
      right: -45px;
      border-radius: 120px 0 0 120px;
    `}
  }

  @media (${tabletMax}) {
    width: calc(100% + 15px);

    ${(props) =>
      props.align === 'left' &&
      `
      left: -15px;
    `}

    ${(props) =>
      props.align === 'right' &&
      `
      right: -15px;
    `}
  }
`;

export const DetailsList = styled.div<{ align: string; bulletColour?: string }>`
  position: relative;
  padding-bottom: 60px;
  margin-top: -60px;

  ${(props) =>
    props.align === 'right' &&
    `
    padding-left: 160px;
  `}

  ${(props) =>
    props.align === 'left' &&
    `
    padding-right: 160px;
  `}
  
  h4 {
    font-family: ${platform.headingFont};
    color: ${(props) => props.theme.white};
    font-size: 40px;
  }

  h5 {
    color: ${(props) => (props.align === 'right' ? props.theme.textDark : props.theme.primary)};
    font-size: 22px;
    margin-top: 30px;
  }

  ul {
    position: relative;
    list-style: none;
    padding-left: 30px;

    li::before {
      content: '•';
      color: ${(props) => props.bulletColour || props.theme.primary};
      font-weight: bold;
      display: inline-block;
      width: 20px;
      margin-left: -20px;
    }
  }

  li {
    color: ${(props) => props.theme.white};
    font-size: 20px;
    margin-bottom: 10px;
  }

  @media (${laptopMaxXL}) {
    margin-top: 0;

    ${(props) =>
      props.align === 'right' &&
      `
    padding-left: 80px;
  `}

    ${(props) =>
      props.align === 'left' &&
      `
    padding-right: 80px;
  `}
  }

  @media (${laptopMax}) {
    ${(props) =>
      props.align === 'right' &&
      `
      padding: 15px 15px 60px 20px;
    `}

    ${(props) =>
      props.align === 'left' &&
      `
      padding: 15px 20px 60px 15px;
    `}
    
    h4 {
      font-size: 30px;
      line-height: 1.1;
    }

    h5 {
      font-size: 20px;
    }

    ul li {
      font-size: 16px;
    }
  }
`;

export const DidYouKnow = styled.div`
  position: absolute;
  top: 30px;
  left: 450px;
  width: 156px;
  height: 156px;
  background-color: ${(props) => props.theme.primary};
  border-radius: 80px;
  padding: 36px 5px 0;
  text-align: center;
  color: ${(props) => props.theme.white};
  font-size: 16px;
  transform: rotate(8deg);

  svg {
    position: absolute;
    top: 125px;
    left: 0;
  }

  @media (max-width: 1500px) {
    position: static;
    margin-left: 60px;

    svg {
      transform: rotate(90deg);
      top: 20px;
      left: -50px;
    }
  }
`;

export const DetailsListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;

  div:first-child {
    margin-right: 20px;
  }

  p {
    color: ${(props) => props.theme.white};
    font-size: 20px;
  }

  @media (${laptopMax}) {
    p {
      font-size: 16px;
    }
  }
`;

export const ListIcon = styled.div`
  width: 70px;
  height: 70px;
  background-color: ${(props) => props.theme.background};
  border-radius: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 50px;
  }

  @media (${laptopMax}) {
    width: 60px;
    height: 60px;

    svg {
      height: 40px;
    }
  }
`;

export const ContactWrapper = styled.div`
  position: relative;
  padding: 120px 0 80px;

  h2 {
    font-family: ${platform.headingFont};
    font-size: 60px;
    line-height: 66px;
  }

  @media (${laptopMax}) {
    padding: 0 0 60px;

    h2 {
      font-size: 30px;
      line-height: 40px;
    }
  }
`;

export const ContactsBg = styled.div`
  background-color: ${BACKGROUND_COLOR};
  width: 75%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0 600px 0 0;
  z-index: -1;

  @media (${laptopMax}) {
    width: 100%;
    border-radius: 0 150px 0 0;
  }
`;

export const ContactForm = styled.form`
  display: block;
  padding: 30px;
  background-color: ${(props) => props.theme.background};
  max-width: 600px;
  width: 100%;
  border-radius: 24px;
  box-shadow: 0 16px 48px 0 rgba(0, 0, 0, 0.16);
  margin-left: 30px;

  h3 {
    text-align: center;
    margin-bottom: 15px;
    color: ${(props) => props.theme.textDark};
  }

  h4 {
    text-align: center;
    color: ${(props) => props.theme.textDark};
    margin-top: 30px;
  }

  > p {
    text-align: center;
    color: ${(props) => props.theme.textDark};
    font-size: 14px;
    margin-top: 15px;
  }

  @media (${laptopMax}) {
    margin: 30px 0 0 0;
    padding: 30px 20px;
  }
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;

  & > div {
    margin-top: 15px;
    margin-left: 15px;
  }

  & > div:first-child {
    margin-left: 0;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;

    & > div {
      margin: 15px 0 0;
    }
  }
`;

export const FAQs = styled.div`
  padding: 60px 0;

  h2 {
    margin-bottom: 30px;
  }
`;

export const FAQText = styled.div`
  max-height: 0;
  transition: all 600ms;
  overflow: hidden;

  p {
    font-size: 16px;
    margin-bottom: 30px;

    a {
      color: ${(props) => props.theme.primary};
    }
  }
`;

export const FAQRow = styled.div<{ active: boolean }>`
  border-bottom: 1px solid ${(props) => props.theme.keyline};

  button {
    width: 100%;
    position: relative;
    font-size: 18px;
    font-weight: 600;
    padding: 30px 30px 30px 0;
    display: flex;
    align-items: center;
    text-align: left;
    color: #000;

    svg {
      position: absolute;
      right: 10px;
      transition: 300ms all;
    }
  }

  &:last-child {
    border-bottom: none;
  }

  ${(props) =>
    props.active &&
    `
    button svg {
      transform: rotate(45deg);
    }
    
    ${FAQText} {
      max-height: 350px;
    }
  `}
`;

export const Tabs = styled(ProductsTabs)`
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  max-width: fit-content;
  margin: 0 auto;
`;
